import Axes from './axes.component';
export default Axes;
